import { render, staticRenderFns } from "./AreaPOACalendar.vue?vue&type=template&id=fb156524"
import script from "./AreaPOACalendar.vue?vue&type=script&lang=js"
export * from "./AreaPOACalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports